import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Select, SelectItem, SelectOption } from "@swivl-mono/ui";
import _ from "lodash";

import { SMSGroupModel } from "../../../../../Models/SMSGroup/SMSGroup.Model";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";
import "./SMSGroup.Node.scss";

const SMSGroupSelect = (props: any) => {
  const { node, deleteGroup, onChange } = props;
  const { intervalGroups, campaignGroups } = SMSGroupModel.useState((s) => ({
    campaignGroups: s.campaignGroups,
    intervalGroups: s.intervalGroups
  }));

  const isLoading = !intervalGroups && !campaignGroups;

  const buildOptions = (): SelectItem[] => {
    const result: SelectItem[] = [];
    if (node.action === "remove") {
      result.push({ value: "REMOVE_FROM_ALL_GROUPS", label: "Remove From All" });
    }
    if (campaignGroups?.length) {
      result.push({
        type: "group",
        label: "Campaign Groups",
        options: [...campaignGroups]
          .sort((a, b) => a.name.localeCompare(b.name))
          .filter((item) => item.slug)
          .map((item) => ({ value: item.slug, label: item.name })) as SelectOption[]
      });
    }
    if (intervalGroups?.length) {
      result.push({
        type: "group",
        label: "Interval Groups",
        options: [...intervalGroups]
          .sort((a, b) => a.name.localeCompare(b.name))
          .filter((item) => item.slug)
          .map((item) => ({ value: item.slug, label: item.name })) as SelectOption[]
      });
    }
    return result;
  };

  const options = buildOptions();

  const groupViews = node.groups.map((item, index) => {
    return (
      <div key={item.id} className="SMSGroupSelect">
        <div className="content">
          <Select
            hasSearchInDropdown
            loading={isLoading}
            options={options}
            selectedValues={item.groupSlug ? [item.groupSlug] : []}
            onChange={(vals) => onChange({ target: { name: "groups." + index + ".groupSlug", value: vals[0] ?? undefined } } as any)}
          />
          <div className="removeButtonRow">
            <span
              className="deleteButtonIcon logicDelete"
              onClick={() => {
                deleteGroup("groups", index);
              }}
            >
              REMOVE
            </span>
          </div>
        </div>
      </div>
    );
  });

  return <div>{groupViews}</div>;
};

const SMSGroup = {
  Type: "SMSGroup",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: SMSGroup.Type,
      text: "",
      goto: "",
      noPhoneNumberGoto: "",
      invalidPhoneNumberGoto: "",
      action: "add",
      groups: []
    };

    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [
      {
        id: "gotoSMSGroup",
        source: "goto",
        target: node.goto,
        title: node.action === "add" ? "Added" : "Removed"
      },
      {
        id: "noPhoneNumberGoto",
        source: "noPhoneNumberGoto",
        target: node.noPhoneNumberGoto,
        title: "No Phone #"
      },
      {
        id: "invalidPhoneNumberGoto",
        source: "invalidPhoneNumberGoto",
        target: node.invalidPhoneNumberGoto,
        title: "Invalid #"
      }
    ];
    const displayText = node.text.length > 23 ? node.text.substring(0, 20) + "..." : node.text;

    return TabNodeLayoutData({
      node: node,
      title: "SMS Group",
      body: displayText,
      baseWidth: 180,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.changeAction = this.changeAction.bind(this);
      this.addGroup = this.addGroup.bind(this);
      //    this.addGroup    = this.addGroup.bind(this)

      SMSGroupModel.loadGroups(false);
    }

    changeAction(event: any) {
      const target = event.target;
      const value = target.type && target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;
      let node = JSON.parse(JSON.stringify(this.props.node));
      node.groups = [];
      _.set(node, name, value);
      this.props.updateNode(node, this.props.node);
    }

    addGroup() {
      this.addItemToArray({ id: RandomId(6), groupSlug: undefined }, "groups", true);
    }

    render() {
      const { node } = this.props;
      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="SMSGroup" />
            <b>Action</b>
            <div className="radioButtons">
              <form>
                <div className="radioItem">
                  <label className="inspectorLabel">
                    <input type="radio" name="action" value="add" onChange={this.changeAction} checked={node.action === "add"} />
                    <span className="radioText">Add</span>
                  </label>
                </div>
                <div className="radioItem">
                  <label className="inspectorLabel">
                    <input type="radio" name="action" value="remove" onChange={this.changeAction} checked={node.action === "remove"} />
                    <span className="radioText">Remove</span>
                  </label>
                </div>
              </form>
            </div>
            <b>Group</b>
            <SMSGroupSelect node={this.props.node} onChange={this.onChange} deleteGroup={this.deleteValue} />

            <div className="addElementButton" onClick={this.addGroup}>
              + ADD GROUP
            </div>
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export { SMSGroup };
